export function isUSPhoneNumber(phoneNumber: string) {
  // Regular expression to match NANP format phone numbers with optional country code
  const regex =
    /^(\+1\s*|1\s*)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

  // Check if the phone number matches the regex
  return regex.test(phoneNumber);
}
